import React, { ReactNode } from 'react';

interface VerticalScreenProps {
  children: ReactNode;
  backgroundColor?: string;
  textColor?: string;
}

function VerticalScreen({
  children,
  backgroundColor = '#fff',
  textColor = '#003DA5',
}: VerticalScreenProps) {
  return (
    <div
      className="flex h-screen max-h-screen flex-col justify-between overflow-hidden"
      style={{ backgroundColor, fontFamily: 'Kanit, sans-serif' }}
    >
      {children}
    </div>
  );
}

export default VerticalScreen;
